import { useContext, useState } from "react";
import { config } from "../context/config";
import { useTranslation } from "react-i18next";
import { intialData } from "../context/initial";
import { CurrentTime } from "../funcs/current";
import { ValidationSupplier } from "../funcs/validation/validateSupplier";
import { action } from "../context/action";
import {
    recodeNow,
    deleteItem,
    update
} from "../components/indexDB/indexDBStora";
import { dataa } from "../context/data";
import { switchh } from "../context/switch";

export default function Suppliers() {
    const { stylingNav } = useContext(config);
    const { initSupplier } = useContext(intialData);
    const { suppliers } = useContext(dataa);
    const { errorMessage, setErrorMessage } = useContext(action);
    const { setLoadingProcess } = useContext(switchh);

    const [supplier, setSupplier] = useState(initSupplier);
    const [isEdit, setIsEdit] = useState(false);

    const { t } = useTranslation();

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone") {
            const onlyNumbers = value.replace(/\D/g, "");

            setSupplier((prev) => ({
                ...prev,
                [name]: onlyNumbers
            }));

            return;
        }

        setSupplier((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const resetForm = () => {
        setSupplier(initSupplier);
        setIsEdit(false);
    };

    const handleEdit = (supp) => {
        setSupplier(supp);
        setIsEdit(true);
    };

    const handleDelete = async (id) => {
        try {
            setLoadingProcess(true);

            await deleteItem("suppliers", id);

            setLoadingProcess(false);
        }
        catch (err) {
            console.log(err);
            setLoadingProcess(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoadingProcess(true);

            const result = ValidationSupplier(supplier);

            if (!result.success) {
                setLoadingProcess(false);
                setErrorMessage(result.message);
                return;
            }

            setErrorMessage("");

            if (isEdit) {
                await update("suppliers", supplier);
            } else {
                const current = CurrentTime(true, true);

                const newSupplier = {
                    ...supplier,
                    createdAt: current
                };

                await recodeNow(newSupplier, "suppliers");
            }

            resetForm();
            setLoadingProcess(false);
        }
        catch (err) {
            console.log(err);
            setLoadingProcess(false);
        }
    };

    return (
        <div
            className={`supplier page ${
                !stylingNav ? "page-grow" : "page-shrink"
            }`}
        >
            <h2 className="pad-10">
                {t("sections:suppliers.full")}
            </h2>

            <form className="pad-10" onSubmit={handleSubmit}>
                <div className="sec flex">
                    <div className="ch">
                        <label>
                            {t("label:supplier.supplierCompany")}
                        </label>

                        <input
                            name="supplierCompany"
                            onChange={handleChange}
                            value={supplier.supplierCompany}
                            className="inp"
                            type="text"
                        />
                    </div>

                    <div className="ch">
                        <label>
                            {t("label:employee.address")}
                        </label>

                        <input
                            name="address"
                            onChange={handleChange}
                            value={supplier.address}
                            className="inp"
                            type="text"
                        />
                    </div>
                </div>

                <div className="sec flex">
                    <div className="ch">
                        <label>
                            {t("label:employee.phoneNumber")}
                        </label>

                        <input
                            name="phone"
                            onChange={handleChange}
                            value={supplier.phone}
                            className="inp"
                            type="text"
                        />
                    </div>

                    <div className="ch">
                        <label>
                            {t("label:supplier.email")}
                        </label>

                        <input
                            name="email"
                            onChange={handleChange}
                            value={supplier.email}
                            className="inp"
                            type="text"
                        />
                    </div>
                </div>

                <div className="sec flex">
                    <div className="ch">
                        <label>
                            {t("label:supplier.supplierName")}
                        </label>

                        <input
                            name="contactPersonName"
                            onChange={handleChange}
                            value={supplier.contactPersonName}
                            className="inp"
                            type="text"
                        />
                    </div>

                    <div className="ch">
                        <label>
                            {t("label:supplier.notes")}
                        </label>

                        <input
                            name="note"
                            onChange={handleChange}
                            value={supplier.note}
                            className="inp"
                            type="text"
                        />
                    </div>
                </div>

                <p className={errorMessage.length ? "error" : ""}>
                    {errorMessage}
                </p>

                <button
                    className="button-zone normal-bg-v2"
                    type="submit"
                >
                    {isEdit
                        ? t("action:edit")
                        : t("action:record")}
                </button>
            </form>

            <div className="table">
                <table className="center">
                    <thead>
                        <tr>
                            <th>
                                {t("label:supplier.supplierCompany")}
                            </th>

                            <th>
                                {t("label:employee.address")}
                            </th>

                            <th>
                                {t("label:employee.phoneNumber")}
                            </th>

                            <th>
                                {t("label:supplier.email")}
                            </th>

                            <th>
                                {t("label:supplier.supplierName")}
                            </th>

                            <th>
                                {t("common:action")}
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {suppliers.length !== 0 &&
                            suppliers.map((supp) => (
                                <tr
                                    className="inp"
                                    key={supp.id}
                                >
                                    <td>
                                        {supp.supplierCompany ||
                                            "--"}
                                    </td>

                                    <td>
                                        {supp.address || "--"}
                                    </td>

                                    <td>
                                        {supp.phone || "--"}
                                    </td>

                                    <td>
                                        {supp.email || "--"}
                                    </td>

                                    <td>
                                        {supp.contactPersonName ||
                                            "--"}
                                    </td>

                                    <td>
                                        <button
                                            type="button"
                                            className="button-zone error-bg"
                                            onClick={() =>
                                                handleDelete(
                                                    supp.id
                                                )
                                            }
                                        >
                                            {t(
                                                "action:delete"
                                            )}
                                        </button>

                                        <button
                                            type="button"
                                            className="button-zone normal-bg"
                                            onClick={() =>
                                                handleEdit(
                                                    supp
                                                )
                                            }
                                        >
                                            {t("action:edit")}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}